import { render, staticRenderFns } from "./AssignmentModal.vue?vue&type=template&id=46e5bf74&scoped=true&"
import script from "./AssignmentModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentModal.vue?vue&type=style&index=0&id=46e5bf74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e5bf74",
  null
  
)

export default component.exports